export function formatSize(bytes?: number): string {
  if (bytes === undefined || bytes === null || bytes < 0) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let unitIndex = 0
  let value = bytes
  while (value >= 1024 && unitIndex < units.length - 1) {
    value = value / 1024
    unitIndex++
  }
  const decimals = unitIndex > 0 && value < 10 ? 1 : 0
  return `${value.toFixed(decimals)} ${units[unitIndex]}`
}

export default { formatSize }


